import type { ComponentProps } from 'react'

import { useFormContext } from 'react-hook-form'

import type { TextButton } from '..'
import { ContinueButton } from '../continue-button'

type ButtonProps = ComponentProps<typeof TextButton>
type ContinueButtonProps = ComponentProps<typeof ContinueButton>
type Props = ButtonProps & Pick<ContinueButtonProps, 'noMargin'>

export const FormSubmitButton = ({ children, disabled, ...other }: Props) => {
  const {
    formState: { isSubmitting },
  } = useFormContext()

  return (
    <ContinueButton
      fullWidth
      data-testid="form-submit-button"
      disabled={isSubmitting || disabled}
      {...other}
    >
      {children}
    </ContinueButton>
  )
}
